/** @format */

import { put, call, select, takeLatest } from 'redux-saga/effects';
import * as caseServices from 'src/services/cases.service';
import * as casesActions from './casesActions';
import * as casesTypes from './casesTypes';

const error = errorObject => {
  return errorObject.response ? errorObject.response : errorObject;
};

export function* getCasesSaga(props) {
  let filters = {};
  let {
    config: { status, statusType, caseType },
  } = props;

  try {
    if (statusType.toLowerCase() === 'all') {
      filters = {
        caseStatusType: statusType,
        pageNumber: 1,
        pageSize: 25,
        caseType: caseType,
        status: status,
      };
    } else if (statusType.toLowerCase() === 'open') {
      filters = {
        caseStatusType: statusType,
        pageNumber: 1,
        pageSize: 25,
        caseType: caseType,
        status: status,
      };
    } else if (statusType.toLowerCase() === 'closed') {
      filters = {
        caseStatusType: statusType,
        pageNumber: 1,
        pageSize: 25,
        caseType: caseType,
        status: status,
      };
    }

    const data = yield call(caseServices.fetchCases, null, filters);
    if (data.success !== true) throw new error(data);
    yield put(casesActions.getCasesSuccess(data));
  } catch (error) {
    console.warn(error);
    yield put(casesActions.getCasesFailure(error));
  }
}

/** Incomplete */
export function* applyFilterSaga({ caseFilters }) {
  try {
    yield put(casesActions.applyFiltersSuccess());
    yield put(casesActions.toggleModal(false));
    yield put(casesActions.getCasesSuccess());
  } catch (error) {
    yield put(casesActions.applyFiltersFailure(error));
  }
}

export function* getCasesMessagesCountsSaga() {
  try {
    const personId = yield select(state => state.login.userInfo.personId);
    const caseManagerId = yield select(state => state.cases.caseManagerId);
    const inboxFilters = yield select(state => state.messaging.inbox.filters);
    const lastInboxDate = yield select(state => (state.messaging.inbox.messages.length ? state.messaging.inbox.messages[0].date : null));
    // const params = {
    //   fromDate: lastInboxDate,
    //   caseManagerId: caseManagerId,
    //   ...inboxFilters,
    //   personId,
    // };
    // const data = yield call(caseServices.fetchCaseMessagesCounts, params);
    const data = {};
    if (data.success) {
      yield put(casesActions.getCaseMessagesCountsSuccess(data));
    }
  } catch (error) {
    console.error(error);
    yield put(casesActions.getCaseMessagesCountsFailure(error));
  }
}

const casesSaga = [
  takeLatest(casesTypes.GET_CASES_PENDING, getCasesSaga),
  takeLatest(casesTypes.APPLY_CASES_FILTERS, applyFilterSaga),
  takeLatest(casesTypes.GET_CASES_MESSAGES_COUNTS_PENDING, getCasesMessagesCountsSaga),
];

export default casesSaga;



// WEBPACK FOOTER //
// ./src/ui/features/Cases/state/casesSaga.js